import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-regular-svg-icons';
import DefaultCPButton from './defaultCommandPanelButton';

function NewButton({ content, onClick, disabled }) {
  return (
    <DefaultCPButton
      content={content}
      onClick={onClick}
      disabled={disabled}
      icon={<FontAwesomeIcon icon={faFile} />}
    />
  );
}

NewButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

NewButton.defaultProps = {
  content: 'Створити',
  disabled: false,
};

export default NewButton;
